/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import {
	CORE_PROJECT,
	SERVICE_DESK_PROJECT,
} from '@jira/platform__project-types/src/project-types.tsx';
import type { ProjectState } from '../model/types.tsx';

export const isJwmProject = (projectState: ProjectState | null): boolean =>
	projectState?.projectType === CORE_PROJECT;

export const isJsmProject = (projectState: ProjectState | null): boolean =>
	projectState?.projectType === SERVICE_DESK_PROJECT;
